/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class DescriptorForRecommendation extends models.RecommendationBase {
    constructor() {
        super();
        this.setDiscriminator("DescriptorForRecommendation");
    }

    getFixupPrototypeFunction() { return DescriptorForRecommendation.fixupPrototype; }

    static newInstance(model: Partial<DescriptorForRecommendation>): DescriptorForRecommendation {
        let obj = Object.assign(new DescriptorForRecommendation(), model);
        DescriptorForRecommendation.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<DescriptorForRecommendation>): DescriptorForRecommendation {
        if (!model) return null;
        return DescriptorForRecommendation.newInstance(<DescriptorForRecommendation> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: DescriptorForRecommendation) {
        if (!obj) return;

        models.DescriptorForRecommendation.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: DescriptorForRecommendation): boolean {
        if (models.RecommendationBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, DescriptorForRecommendation.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (typeof this.touched_at === "string") {
            this.touched_at = new Date(<string><any>this.touched_at);
        }
        if (typeof this.event_at === "string") {
            this.event_at = new Date(<string><any>this.event_at);
        }
    }

    /**
     * Definition System ID
     */
    definition_sys_id: string;

    /**
     * Document updated Time
     */
    touched_at: Date;

    /**
     * Impact of the policy resource recommendation
     */
    impact: models.PolicyResourceRecommendationImpact;

    /**
     * Indicates the status of the recommendation which has been generated in corestack
     */
    status: models.ResourceRecommendationStatus;

    /**
     * Date and time when the recommendation was generated/resolved.
     */
    event_at: Date;

    /**
     * Additional information which needs to be manually posted by the customers.
     */
    remarks: string;

    /**
     * Service Account Id
     */
    service_account_id: string;

}
